
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Tasks',
  data () {
    return {
      tasks: [
        {
          name: 'Design mockup',
          desc: 'Create full rendering of design for client\'s web-product. Client K&H Science',
          deadLine: '12.11',
          id: 111
        },
        {
          name: 'Analysis of requirements and outcomes',
          desc: 'Evaluate the product design and development against project requirements and outcomes',
          deadLine: '14.12',
          id: 222
        },
        {
          name: 'Application Testing',
          desc: 'Identify errors in a website, provide unit, system and functional testing',
          deadLine: '21.11',
          id: 333
        }
      ]
    }
  }
})
